import { CompanyInvoice } from "./company-invoice.model";
import { PersonInvoice } from "./person-invoice.model";

export class SaveCompanyInvoiceRequest{
  companyInvoice: CompanyInvoice
  personInvoice: PersonInvoice
}
